export default __webpack_public_path__ + "static/media/about_1.4eae0fa3.jpg";